import get from "lodash/get";
import { useGetOne, WithRecord } from "react-admin";
import { MyDateField } from "../../ra-lb-tools/components/myDateField";

export const TowerTimezonedDate = ({ towerId, ...props }) => {
  const { data } = useGetOne("towers", { id: towerId });

  const timezones = get(data, "location.timezone")
    ? { LT: get(data, "location.timezone") }
    : null;

  return <MyDateField {...props} timezones={timezones} fixNoTimezone={true} />;
};

export const TowerTimezonedDateField = (props) => {
  return (
    <WithRecord
      render={(record) => (
        <TowerTimezonedDate {...props} towerId={record.towerId} />
      )}
    />
  );
};
